import { lazyWithPreload } from 'react-lazy-with-preload'; 

export const icons = {
  'lizzy-autocomplete-dropdown': lazyWithPreload(() => import('components/icons/AutocompleteDropdown')),
  'lizzy-autocomplete-inline': lazyWithPreload(() => import('components/icons/AutocompleteInline')),
  'lizzy-autocomplete-off': lazyWithPreload(() => import('components/icons/AutocompleteOff')),
  'lizzy-autocomplete': lazyWithPreload(() => import('components/icons/Autocomplete')),
  'lizzy-continue-writing': lazyWithPreload(() => import('components/icons/ContinueWriting')),
  'lizzy-contract-overview': lazyWithPreload(() => import('components/icons/ContractOverview')),
  'lizzy-definition': lazyWithPreload(() => import('components/icons/Definition')),
  'lizzy-logo-btn': lazyWithPreload(() => import('components/icons/LogoBtn')),
  'lizzy-logo-colored-text': lazyWithPreload(() => import('components/icons/LogoColoredText')),
  'lizzy-logo-colored': lazyWithPreload(() => import('components/icons/LogoColored')),
  'lizzy-logo-grey-small': lazyWithPreload(() => import('components/icons/LogoGreySmall')),
  'lizzy-logo-plain': lazyWithPreload(() => import('components/icons/LogoPlain')),
  'lizzy-longer': lazyWithPreload(() => import('components/icons/Longer')),
  'lizzy-more-vertical': lazyWithPreload(() => import('components/icons/MoreVertical')),
  'lizzy-refresh': lazyWithPreload(() => import('components/icons/Refresh')),
  'lizzy-send-chat': lazyWithPreload(() => import('components/icons/SendChat')),
  'lizzy-send': lazyWithPreload(() => import('components/icons/Send')),
  'lizzy-sentence-ac': lazyWithPreload(() => import('components/icons/SentenceAc')),
  'lizzy-shorten': lazyWithPreload(() => import('components/icons/Shorten')),
  'lizzy-sidebar': lazyWithPreload(() => import('components/icons/Sidebar')),
  'lizzy-summarize': lazyWithPreload(() => import('components/icons/Summarize'))
};